module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "form",
      rawName: "v-form",
      value: ('back-bu-info'),
      expression: "'back-bu-info'"
    }]
  }, [_c('div', {
    staticClass: "base-item"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "two"
  }, [_c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("BU名称")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.name),
      expression: "sub.name"
    }],
    staticClass: "top-choose z-mid",
    attrs: {
      "rule": "noVal",
      "placeholder": "请输入BU名称"
    },
    model: {
      value: (_vm.sub.name),
      callback: function($$v) {
        _vm.$set(_vm.sub, "name", $$v)
      },
      expression: "sub.name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("BU合伙人")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap text"
  }, [_vm._v(_vm._s(_vm.sub.leader_name || "暂无"))])])]), _vm._v(" "), _c('div', {
    staticClass: "back-item area"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("BU职责")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('textarea', {
    directives: [{
      name: "arg",
      rawName: "v-arg",
      value: ('BU职责描述'),
      expression: "'BU职责描述'"
    }, {
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.description),
      expression: "sub.description"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.sub.description),
      expression: "sub.description"
    }],
    attrs: {
      "rule": "reason describe_limit",
      "placeholder": "请BU职责描述"
    },
    domProps: {
      "value": (_vm.sub.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sub, "description", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "base-item"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("\n                经营范围\n                "), _c('el-checkbox', {
    on: {
      "change": _vm.manageAll
    },
    model: {
      value: (_vm.sub_checkall),
      callback: function($$v) {
        _vm.sub_checkall = $$v
      },
      expression: "sub_checkall"
    }
  })], 1), _vm._v(" "), _c('el-checkbox-group', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub_str),
      expression: "sub_str"
    }],
    on: {
      "change": _vm.manageCheck
    },
    model: {
      value: (_vm.sub.sub_tpl_ids),
      callback: function($$v) {
        _vm.$set(_vm.sub, "sub_tpl_ids", $$v)
      },
      expression: "sub.sub_tpl_ids"
    }
  }, _vm._l((_vm.taskTpl), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.tpl_name))])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "base-item"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("\n                发布范围\n                "), _c('el-checkbox', {
    on: {
      "change": _vm.releaseAll
    },
    model: {
      value: (_vm.pub_checkall),
      callback: function($$v) {
        _vm.pub_checkall = $$v
      },
      expression: "pub_checkall"
    }
  })], 1), _vm._v(" "), _c('el-checkbox-group', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.pub_str),
      expression: "pub_str"
    }],
    on: {
      "change": _vm.releaseCheck
    },
    model: {
      value: (_vm.sub.pub_tpl_ids),
      callback: function($$v) {
        _vm.$set(_vm.sub, "pub_tpl_ids", $$v)
      },
      expression: "sub.pub_tpl_ids"
    }
  }, _vm._l((_vm.taskTpl), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.tpl_name))])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "base-item"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("奖金状况")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, _vm._l((_vm.bonus_list), function(item) {
    return _c('span', {
      key: item.currency_id
    }, [_vm._v(_vm._s(((item.currency_name) + "：" + (item.current_currency_balance))))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "base-item"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("预算状况")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, _vm._l((_vm.budget_list), function(item) {
    return _c('div', {
      key: item.currency_id
    }, [_c('span', [_vm._v(_vm._s(((item.currency_name) + "：" + (item.currency_budget) + "(冻结：" + (item.currency_budget_frozen) + ")")))]), _vm._v(" "), _c('span', [_vm._v("预算完成率：" + _vm._s(((item.used_rate/100) + "%")))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "back-btn blue",
    class: {
      disabled: !_vm.now_form.changeFlag
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('div', {
    staticClass: "back-btn",
    class: {
      disabled: !_vm.now_form.changeFlag
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-494fa7f0!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/person/bu/detail-info.vue
// module id = 738
// module chunks = 1